module.exports = __webpack_public_path__ + "img/logo2.2be0b496.png";